'use client';

import React, { ReactNode } from 'react';
import { ChevronLeft } from 'lucide-react';
import { cn } from '@ecom/helper-react-class-combine';
import { useCarouselContext } from '../carousel-context';

interface ArrowProps {
  className?: string;
  /** Custom icon. Falls back to a chevron when omitted. */
  children?: ReactNode;
}

export function CarouselPrevious({ className, children }: ArrowProps): React.ReactElement | null {
  const { canPrev, scrollPrev, slideCount, labels } = useCarouselContext();
  if (slideCount <= 1) return null;
  return (
    <button
      type='button'
      aria-label={labels.prevSlide}
      onClick={scrollPrev}
      disabled={!canPrev}
      className={cn(
        'disabled:pointer-events-none disabled:opacity-40',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-current',
        className,
      )}
    >
      {children ?? <ChevronLeft size={32} aria-hidden='true' />}
    </button>
  );
}
